export interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

export type ExperimentMap = Record<string, ExperimentData>;
export type ExperimentData = Record<string, unknown>;

export enum SearchEventCardClickBehaviourExperimentValues {
    control = 'control',
    fullClick = 'full_click',
    // "Call to action"
    cta = 'cta',
}

export const SearchEventCardClickBehaviourExperiment: Experiment<
    typeof SearchEventCardClickBehaviourExperimentValues
> = {
    name: 'search_event_card_click_behavior',
    paramName: 'click_behavior',
    values: SearchEventCardClickBehaviourExperimentValues,
};

export const HomepageSeasonalCarouselValues = {
    control: 'hide',
    test: 'show',
};

export const HomepageSeasonalCarouselExperiment: Experiment<
    typeof HomepageSeasonalCarouselValues
> = {
    name: 'mardi_gras_new_orleans',
    paramName: 'mardi_gras_carousel',
    values: HomepageSeasonalCarouselValues,
};

export const DatingInNightlifeValues = {
    control: 'hide',
    test: 'show',
};

export const DatingInNightlifeExperiment: Experiment<
    typeof DatingInNightlifeValues
> = {
    name: 'dating_carousel_on_homepage',
    paramName: 'dating_tab',
    values: DatingInNightlifeValues,
};

export const SearchDesktopStaticMapImageValues = {
    control: 'hide',
    variant: 'show',
};
export const SearchDesktopStaticMapImageExperiment: Experiment<
    typeof SearchDesktopStaticMapImageValues
> = {
    name: 'search-desktop-static-map-image',
    paramName: 'static-map',
    values: SearchDesktopStaticMapImageValues,
};
